var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"mt-2"},[_c('v-col',{attrs:{"md":"12"}},[_c('v-card',[_c('v-card-text',[_vm._v(" This Platform is conducted for reporting all the actions on ardkon.com ")])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }